module.exports = __webpack_public_path__ + "static/media/1537.c93a35cd.jpg";